<template>
  <div class="root">
    <div class="login flex items-center">
      <h3 class="text-5xl">Hata</h3>
      <p>Bu şekilde kayıtlı bir crm yok, bulunamadı</p>
      <p>
        Crminiz daha sonradan oluştuysa eğer,
        <a href="/"> buraya tıklayarak </a>
        bağlanmayı tekrar deneyin.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      loading: false,
      form: [],
      messages: [],
      login: false
    };
  },
  created() {},
  methods: {}
};
</script>
<style>
.root {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.login {
  width: 350px;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
}

.login-marg {
  margin-bottom: 10px;
}

.login-button {
  margin-top: 10px;
}
</style>
